// src/lib/portfolioSnapshots.js
// Save and retrieve portfolio value snapshots from the portfolio_snapshots table.

import { supabase, hasSupabase } from './supabaseClient';

export async function saveSnapshot(userId, value, triggerType, notes = null) {
  if (!hasSupabase || !userId) return;

  const { error } = await supabase
    .from('portfolio_snapshots')
    .insert({
      user_id: userId,
      value,
      trigger_type: triggerType,
      notes,
    });

  if (error) {
    console.error('[portfolioSnapshots] Failed to save snapshot:', error.message);
  }
}

export async function getCurrentPortfolioValue(userId) {
  if (!hasSupabase || !userId) return null;

  const { data, error } = await supabase
    .from('user_preferences')
    .select('portfolio_value')
    .eq('user_id', userId)
    .single();

  if (error || !data) return null;
  return data.portfolio_value;
}

export async function getSnapshotHistory(userId, limit = 90) {
  if (!hasSupabase || !userId) return [];

  const { data, error } = await supabase
    .from('portfolio_snapshots')
    .select('value, trigger_type, snapshot_at')
    .eq('user_id', userId)
    .order('snapshot_at', { ascending: true })
    .limit(limit);

  if (error) {
    console.error('[portfolioSnapshots] Failed to load history:', error.message);
    return [];
  }

  return data;
}
